import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'map-layer-opacity-slider',
  templateUrl: 'map-layer-opacity-slider.component.html',
  styleUrls: ['map-layer-opacity-slider.component.scss']
})
export class MapLayerOpacitySliderComponent implements OnInit {
  @Input() value = 1;
  @Output() valueChange = new EventEmitter<number>();
  visibleValue = 100;

  ngOnInit() {
    this.visibleValue = Math.round(this.value * 100);
  }

  onChange(event: any) {
    this.value = +event.target.value;
    this.visibleValue = Math.round(this.value * 100);
    this.valueChange.emit(this.value);
  }
}
